import { $, Selector } from '@zeus/index';
import { typedGql } from '@zeus/typedDocumentNode';
import { scalars } from '~/gql/utils/scalars';

const notificationSelector = Selector('BattleNotification')({
  from: true,
  type: true,
  isWinner: true,
  battlePlayerTrackingId: true,
});

export const GQL_BATTLE_SUBSCRIPTION = typedGql('subscription', { scalars })({
  battleSubscription: [
    {
      username: $('username', 'String!'),
    },
    notificationSelector,
  ],
});
